const dev = {
  environment: 'dev',
  production: false,
    API_URL: 'https://rastromonitor.azultecnologia.com/api/',
  // API_URL: "http://localhost:8082/api/",

  mapConfig: {
    street:
      'https://{1-3}.traffic.maps.api.here.com/maptile/2.1/traffictile/newest/normal.day/{z}/{x}/{y}/256/png8?app_id=kw40mQz9OsBEkRlcURmr&app_code=K-zerLtDzSDv6nw3wQid4A',
    satellite:
      'https://{1-3}.aerial.maps.api.here.com/maptile/2.1/maptile/newest/hybrid.day/{z}/{x}/{y}/256/jpg?app_id=kw40mQz9OsBEkRlcURmr&app_code=K-zerLtDzSDv6nw3wQid4A',
  },
    socketURL: 'wss://rastromonitor.azultecnologia.com/api/socket',
 // socketURL: "ws://localhost:8082/api/socket",
  traceLimit: 5,
  eventLimit: 200,
  PATH: {
    device_icons: `${process.env.PUBLIC_URL}/images/device_icons`,
  },
  azulPay: {
    url: 'https://sandboxazulpay.pagtech.me/api/v1',
    base: 'https://sandboxazulpay.pagtech.me'
  },
};

const prod = {
  environment: window.location.hostname,
  production: true,
  API_URL: 'https://server.monitorando.me/api/',
  socketURL: 'wss://server.monitorando.me/api/socket',
  azulPay: {
    url: 'https://www.azulpay.online/api/v1',
    base: 'https://www.azulpay.online'
  },
};

const config = process.env.REACT_APP_ENV === 'prod' ? {...dev, ...prod} : dev;

export default {...config};
